import { graphql, useStaticQuery } from "gatsby";
import { ServiceIndexOurProcessQuery } from "./query.generated";

export type CMSOurProcessData = ServiceIndexOurProcessQuery["cms"]["site"];

export function useStaticOurProcessQuery(): CMSOurProcessData {
  const data = useStaticQuery<ServiceIndexOurProcessQuery>(
    graphql`
      query ServiceIndexOurProcess {
        cms {
          site(hostname: "www.italymondo.com") {
            serviceIndexPage: pages(
              contentType: "italymondo_services.IMServiceIndexPage"
            ) {
              ... on CMS_IMServiceIndexPage {
                process {
                  cta {
                    page {
                      url
                    }
                    title
                  }
                  description
                  steps {
                    description
                    name
                    step
                  }
                  title
                }
                processMedia {
                  ... on CMS_MediaImagesBlock {
                    __typename
                    images {
                      image {
                        alt
                        url
                        urlSharp {
                          childImageSharp {
                            gatsbyImageData(
                              placeholder: BLURRED
                              width: 650
                              height: 550
                            )
                          }
                        }
                      }
                    }
                  }
                  ... on CMS_TestimonialsBlock {
                    __typename
                    testimonials {
                      testimonial {
                        date
                        longMessage
                        name
                        photo {
                          alt
                          url
                          urlSharp {
                            childImageSharp {
                              gatsbyImageData(
                                height: 60
                                width: 60
                                placeholder: BLURRED
                              )
                            }
                          }
                        }
                        sourceDetail {
                          logo {
                            title
                            url
                          }
                          url
                        }
                      }
                    }
                  }
                }
                processMediaPlacement
                processSectionName
              }
            }
          }
        }
      }
    `
  );
  return data.cms.site;
}
